import toastUtils from "../utils/toastUtils";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

const toastError = err => {
	const errorMsg = err.response?.data?.error;
	
	// Extrair título do erro baseado no contexto
	const getErrorTitle = (errorMsg) => {
		if (errorMsg?.includes('ERR_NO_PERMISSION')) return "Sem Permissão";
		if (errorMsg?.includes('ERR_USER_CREATION_DISABLED')) return "Criação Desabilitada";
		if (errorMsg?.includes('ERR_NO_PLAN_FOUND')) return "Plano Inválido";
		if (errorMsg?.includes('ERR_WAPP_NOT_INITIALIZED')) return "WhatsApp Offline";
		if (errorMsg?.includes('ERR_SENDING_WAPP_MSG')) return "Erro no Envio";
		if (errorMsg?.includes('ERR_DUPLICATE_CONTACT')) return "Contato Duplicado";
		if (errorMsg?.includes('ERR_OPEN_USER_TICKET')) return "Ticket Aberto";
		if (errorMsg?.includes('ERR_OUT_OF_HOURS')) return "Fora do Horário";
		if (errorMsg?.includes('ERR_NO_INTEGRATION_FOUND')) return "Integração Ausente";
		return "Erro";
	};
	
	if (errorMsg) {
		const title = getErrorTitle(errorMsg);
		const message = i18n.exists(`backendErrors.${errorMsg}`) 
			? i18n.t(`backendErrors.${errorMsg}`) 
			: errorMsg;
			
		toastUtils.error(message, title, { toastId: errorMsg });
		return;
	}
	
	if (isString(err)) {
		toastUtils.error(err, "Erro");
		return;
	}
	
	toastUtils.error("Ocorreu um erro inesperado", "Erro");
};

export default toastError;
